import {
    COUNTRY_CLAUSE_LIST,
    COUNTRY_CLAUSE_REGION_LIST,
    COUNTRY_CLAUSE_PAGINATION
} from './constant';
import { APICall } from '@/config/NetworkUtility';
import { setAuthToken } from '@/utility/CommonConstant';


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const GetMasterRegion = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetCompanyAddressList?${queryParams}`;
        const url = `v1/CountryClause/GetMasterRegion`;
        return APICall('get', payload, url).then(result => {
            console.log('ddddddddddddddddd', result);
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: COUNTRY_CLAUSE_REGION_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: COUNTRY_CLAUSE_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};


/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const GetCountryClausesList = (payload) => {
    return dispatch => {
        const queryParams = new URLSearchParams({
            ...payload,
        }).toString();
        // const url = `v1/AddressBook/GetClauseList?${queryParams}`;
        const url = `v1/CountryClause/GetCountryClausesList?${queryParams}`;
        return APICall('get', payload, url).then(result => {
           
            if (result?.statuscode === 200 || result?.statuscode === 201) {
                dispatch({
                    type: COUNTRY_CLAUSE_LIST,
                    payload: result?.data || [],
                });
                dispatch({
                    type: COUNTRY_CLAUSE_PAGINATION,
                    payload: result?.pagination || {},
                });
                return result?.data;
            } else {
                return Promise.reject();
            }
        }, error => {
            return Promise.reject(error);
        });
    };
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const CreateCountryClauses = (payload) => {
    const url = `v1/CountryClause/InsertCountryClauses`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            // const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};

/**
 * 
 * @param {*} payload 
 * @returns 
 */
export const UpdateCountryClauses = (payload) => {
    const url = `v1/CountryClause/UpdateCountryClauses`;
    return APICall('post', payload, url).then(async result => {
        if (result?.statuscode === 201 || result?.statuscode === 200) {
            const payList = { IPageNo: 1, IPageRecords: 10, FilterType: 'ALL', SearchKeyword: '' }
            // await getAddressBookList(payList);
            return result;
        } else {
            return false;
        }
    }, error => {
        return error;
    });
};





